
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitodhulecabs() {



    const cardData =
    {
        keyword: ' Mumbai to Dhule Cab  ',
        heading: 'Deva Cabs: Mumbai to Dhule Cab   ',
        headingDescription: 'Deva Cabs offers safe and reliable cab services from Mumbai to Dhule, ideal for long-distance travel, business trips, and family visits. Covering a distance of approximately 350 km, our well-maintained vehicles—Sedans, SUVs, and Innova Crysta—ensure a smooth and comfortable journey through scenic highway routes. Travel confidently with our experienced chauffeurs, enjoy fixed fare packages, and benefit from convenient door-to-door pickup. With 24/7 availability and transparent pricing, Deva Cabs makes your Mumbai to Dhule cab journey efficient, stress-free, and enjoyable.',

        top: 'Top Places to Visit in Dhule with Deva Cabs',

"topPlaces": [
  {
    "title": "Laling Fort",
    "location": "Laling, Dhule District, Maharashtra",
    "description": "A hilltop fort built during the Faruqi kings’ era, Laling Fort stands in ruins but offers panoramic views of Dhule city. It also features two Hemadpanthi temples, rock-cut cisterns, and historical escape routes." 
  },
  {
    "title": "Songir Fort",
    "location": "Songir, Dhule District, Maharashtra",
    "description": "An easy 20-minute climb takes you to this narrow-strip fort on the confluence of two highways. Dating from the Faruqi period and later held by the Mughals, Marathas & British, it features multiple small forts, deep water wells, and temple ruins." 
  },
  {
    "title": "Bhamer Fort",
    "location": "Sakri Taluka, Dhule District, Maharashtra",
    "description": "Also known as Bhamer, this hill fort is famous for its caves (‘Gavali Raja’s houses’), rock-cut water cisterns, underground chambers, and a mix of Hindu and Jain sculptures—reflecting medieval engineering and religion." 
  },
  {
    "title": "Thalner Fort",
    "location": "Thalner, Shirpur Taluka, Dhule District, Maharashtra",
    "description": "Set on the Tapi River, this 12th-century fort was the first capital of the Faruqi dynasty. Though dilapidated, its riverside location, old stone temple, and medieval walls offer a glimpse into Khandesh’s history." 
  },
  {
    "title": "Rajwade Research Center & Museum",
    "location": "Dhule, Maharashtra",
    "description": "Dedicated to historian V.K. Rajwade, this research library and museum houses rare manuscripts, inscriptions and archival documents in multiple scripts. A hub for scholars and history enthusiasts." 
  },
  {
    "title": "Ekvira Devi Temple",
    "location": "Dhule, Maharashtra",
    "description": "A revered local temple listed among Dhule’s top attractions, frequented by devotees especially during festivals and fairs." 
  },
  {
    "title": "BAPS Shri Swaminarayan Mandir",
    "location": "Dhule, Maharashtra",
    "description": "A prominent modern Swaminarayan temple known for its clean architecture, spiritual ambience, and active community events." 
  },
  {
    "title": "Indira Garden & Shiv Tirth Park",
    "location": "Dhule, Maharashtra",
    "description": "A public green space with lawns, walking paths, and family recreation spots in the heart of Dhule city." 
  },
  {
    "title": "Aner Dam Wildlife Sanctuary",
    "location": "Shirpur Taluka, Dhule District, Maharashtra",
    "description": "A protected sanctuary around Aner Dam in the Satpura hills, home to leopards, blackbuck, deer, birds and Butea forests. Ideal for nature lovers and eco‑tourists." 
  },
  {
    "title": "Nakane/Nakane Lake",
    "location": "Near Dhule, Maharashtra",
    "description": "A small scenic lake near the city used for evening strolls, bird-watching, and local monsoon visits." 
  }
],



   "services": [
    {
      "name": "Mumbai to Dhule Cab",
      "description": "Travel from Mumbai to Dhule with comfort and reliability using our dedicated cab services. Whether you're heading for business, a family visit, or personal travel, our well-maintained fleet ensures a safe and smooth ride. Enjoy door-to-door pickup, experienced chauffeurs, and flexible scheduling for one-way or round trips. Choose from economy to premium vehicle options as per your needs."
    },
    {
      "name": "Taxi service Mumbai to Dhule",
      "description": "Our taxi service from Mumbai to Dhule provides convenient, 24x7 transportation with professional drivers and comfortable vehicles. We offer both one-way and round trip services with a focus on punctuality and customer satisfaction. Ideal for all types of travelers, including individuals, families, and corporate clients."
    },
    {
      "name": "One-way cab hire Mumbai to Dhule",
      "description": "Need a single trip from Mumbai to Dhule? Our one-way cab hire service gives you the freedom to travel without worrying about return arrangements. Choose from sedans, SUVs, or luxury cars with AC and spacious interiors, all at competitive rates."
    },
    {
      "name": "Chauffeur-driven Dhule taxi from Mumbai",
      "description": "Enjoy a comfortable ride with our chauffeur-driven taxi service from Mumbai to Dhule. All our drivers are trained, courteous, and experienced with long-distance routes. This premium service is perfect for stress-free travel, whether you're traveling for business or leisure."
    },
    {
      "name": "SUV cab Mumbai to Dhule",
      "description": "Travel in comfort and style with our SUV cabs from Mumbai to Dhule. Spacious interiors, powerful performance, and air-conditioned cabins make our SUVs ideal for families and groups. Book in advance to ensure availability and get the best travel experience."
    },
    {
      "name": "Round trip cab Mumbai to Dhule",
      "description": "Planning a return journey? Our round trip cab service between Mumbai and Dhule offers the convenience of one booking for both legs of your trip. Enjoy a reliable vehicle, flexible travel plans, and professional drivers to make your round journey hassle-free."
    },
    {
      "name": "Book cab Mumbai to Dhule online",
      "description": "Easily book your Mumbai to Dhule cab online through our seamless platform. Get instant confirmation, transparent pricing, and a range of vehicle options to choose from. Avoid last-minute hassles by securing your ride in just a few clicks."
    },
    {
      "name": "Affordable taxi hire Mumbai to Dhule",
      "description": "Looking for budget-friendly travel options? Our affordable taxi hire from Mumbai to Dhule provides excellent value without compromising on comfort or safety. We offer competitive rates and clean, reliable vehicles to ensure a pleasant journey for all passengers."
    }
  ],
  "tableData": [
    ["Mumbai to Dhule Cab", "-Taxi service Mumbai to Dhule"],
    ["One-way cab hire Mumbai to Dhule", "-Chauffeur-driven Dhule taxi from Mumbai"],
    ["SUV cab Mumbai to Dhule", "-Round trip cab Mumbai to Dhule"],
    ["Book cab Mumbai to Dhule online", "-Affordable taxi hire Mumbai to Dhule"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Dhule Cab Service",
    "WhyChoosedescription": "Experience a smooth and comfortable journey from Mumbai to Dhule with our dependable cab service. Ideal for business travelers, families, and groups, we ensure timely pickups and a hassle-free trip covering the approximately 320 km route. Trust our professional drivers and well-maintained vehicles to make your travel stress-free and enjoyable."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Medium-Distance Travel",
    "WhyChoosedescription": "Our fleet features air-conditioned cars and SUVs with ample legroom and luggage capacity, ensuring a relaxing ride for solo travelers, families, or groups. With modern amenities and ergonomic seating, your journey to Dhule will be comfortable and pleasant."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Dhule Route",
    "WhyChoosedescription": "Our professional drivers are well-versed with the best routes and traffic conditions between Mumbai and Dhule. They prioritize safety, punctuality, and passenger comfort, navigating highways efficiently to ensure a timely and secure journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer upfront pricing inclusive of tolls, fuel, and driver allowances, with no hidden charges. Our competitive rates allow you to plan your budget confidently, making our Mumbai to Dhule cab service both affordable and reliable."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Our cab service operates round the clock to accommodate your preferred travel times. Whether you want an early morning departure or a late-night trip, we provide the flexibility to suit your schedule."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Dhule cab is simple and convenient via our website or customer support. Receive instant confirmation along with fare details and driver information to plan your trip confidently."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles undergo regular maintenance and sanitation before every journey. Equipped with seat belts, GPS tracking, and emergency kits, we prioritize your safety and comfort throughout the trip."
  },
  {
    "WhyChooseheading": "Customizable Travel Packages",
    "WhyChoosedescription": "We offer flexible travel packages including one-way, round trip, and multi-day options with stops at points of interest. Our services can be tailored to meet your specific travel requirements for the Mumbai to Dhule route."
  }
]

















    }








const faqData = [
  {
    question: "Can I book a cab from Mumbai to Dhule with Deva Cabs?",
    answer: "Yes, Deva Cabs offers comfortable and safe cab services from Mumbai to Dhule for business, personal, and long-distance travel needs."
  },
  {
    question: "How long does the journey from Mumbai to Dhule take by cab?",
    answer: "The trip usually takes around 7 to 9 hours depending on the traffic and chosen route."
  },
  {
    question: "What vehicle options are available for the Mumbai to Dhule trip?",
    answer: "We offer a wide range of vehicles such as sedans, SUVs, Innova Crysta, Ertiga, and tempo travellers for individuals and groups."
  },
  {
    question: "Is one-way cab booking available for Mumbai to Dhule?",
    answer: "Yes, Deva Cabs provides both one-way and round-trip cab services for this route."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Tolls, parking fees, and driver allowance are generally additional and will be transparently shared at the time of booking."
  },
  {
    question: "Is the Mumbai to Dhule cab service available 24/7?",
    answer: "Yes, our cab service operates round-the-clock so you can travel anytime that suits your schedule."
  },
  {
    question: "Is it safe to travel with Deva Cabs on long routes?",
    answer: "Absolutely. All our drivers are professional, experienced, and background-verified to ensure your safety."
  },
  {
    question: "Can I request halts or stopovers along the way?",
    answer: "Yes, you can request scheduled halts or stopovers during your Mumbai to Dhule journey."
  },
  {
    question: "Is this service suitable for senior citizens and families?",
    answer: "Yes, our spacious and well-maintained vehicles are ideal for families, senior citizens, and children."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Dhule cab service?",
    answer: "Deva Cabs ensures punctuality, transparent pricing, experienced drivers, and well-maintained cars for a reliable journey."
  }
];

const testimonialData = [
  {
    id: 63,
    name: 'Mr. Aniket More',
    role: 'Solo Traveler',
    review: 'Booked a cab from Mumbai to Dhule with Deva Cabs. The driver was polite, and the journey was smooth and safe.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 64,
    name: 'Mrs. Vaishali Thakur',
    role: 'Family Traveler',
    review: 'Our Mumbai to Dhule cab was clean and comfortable. Deva Cabs delivered excellent service and punctual pickup.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Dhule Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-dhule-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Dhule cab online with Deva Cabs. Reliable one-way and round-trip taxi service with options including AC, SUV, and chauffeur-driven cabs. Comfortable and affordable ride to Dhule.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "432"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8100",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-dhule-cab" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Dhule Cab | One-Way & Round Trip Taxi | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Dhule cab with Deva Cabs. Get affordable one-way and round trip taxi service with options like AC, SUV, and chauffeur-driven cabs. Comfortable ride from Mumbai to Dhule." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Dhule Cab, Taxi service Mumbai to Dhule, One-way cab hire Mumbai to Dhule, Chauffeur-driven Dhule taxi from Mumbai, SUV cab Mumbai to Dhule, Round trip cab Mumbai to Dhule, Book cab Mumbai to Dhule online, Affordable taxi hire Mumbai to Dhule" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitodhulecabs;